import React, { useState } from "react"
import Page from "../../common/page/Page"
import Form from "../../common/form/Form"
import { Link, useNavigate } from "react-router-dom"
import LoginIcon from "../../icons/LoginIcon"
import axios from "axios"
// import { useAuth } from "../../data/useAuth"
import Loader from "../../common/loader/Loader"
import FlashMessage from "../../common/FlashMesage/FlashMessage"
import { useFlashMessage } from "../../common/hook/useFlashMessage"
import styles from "../../common/form/form.module.css"

const SignUp = () => {
  const { flash, showMessage, hideMessage } = useFlashMessage()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
  })

  const [passwordError, setPasswordError] = useState("")

  // const { signIn } = useAuth()

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }))

    if (name === "password" || name === "confirmPassword") {
      // Clear error when user starts typing again
      setPasswordError("")
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    const phoneRegex = /^\d{10,15}$/

    // Frontend validation (mirroring backend)
    if (!formData.firstName.trim()) {
      return showMessage({
        message: "First name is required",
        type: "error",
        mode: "auto",
      })
    }

    if (!formData.lastName.trim()) {
      return showMessage({
        message: "Last name is required",
        type: "error",
        mode: "auto",
      })
    }

    if (!formData.email.trim() || !emailRegex.test(formData.email)) {
      return showMessage({
        message: "Invalid email address",
        type: "error",
        mode: "auto",
      })
    }

    if (!formData.phone.trim() || !phoneRegex.test(formData.phone)) {
      return showMessage({
        message: "Phone number must be 10 to 15 digits",
        type: "error",
        mode: "auto",
      })
    }

    if (!formData.password || formData.password.length < 6) {
      return showMessage({
        message: "Password must be at least 6 characters",
        type: "error",
        mode: "auto",
      })
    }

    if (formData.password !== formData.confirmPassword) {
      return showMessage({
        message: "Passwords do not match",
        type: "error",
        mode: "auto",
      })
    }

    const userData = {
      first_name: formData.firstName,
      last_name: formData.lastName,
      email: formData.email,
      phone_number: formData.phone,
      password: formData.password,
    }

    try {
      setLoading(true)
      const createdUser = await createUser(userData)
      console.log("User created:", createdUser)

      showMessage({
        message:
          "Account created successfully. Please check your email to activate your account.",
        type: "success",
        mode: "auto",
      })

      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        password: "",
        confirmPassword: "",
      })

      setTimeout(() => navigate("/login"), 1000)
    } catch (error) {
      showMessage({ message: error.message, type: "error", mode: "auto" })
    } finally {
      setTimeout(() => setLoading(false), 1000)
    }
  }

  const createUser = async (userData) => {
    try {
      const response = await axios.post("/api/auth/signup", userData)
      return response.data
    } catch (error) {
      if (error.response) {
        console.error("Server Error:", error.response.data)
        throw new Error(error.response.data.error || "Failed to create user")
      } else if (error.request) {
        console.error("Network Error:", error.request)
        throw new Error("Network error, please try again later.")
      } else {
        console.error("Error:", error.message)
        throw new Error("An unexpected error occurred.")
      }
    }
  }

  return (
    <Page title={"Create Account"} searchDisabled={true}>
      {loading ? (
        <div style={{ display: "flex", height: "calc(80vh - 100px)" }}>
          <Loader />
        </div>
      ) : (
        <Form onSubmit={handleSubmit}>
          <div className={styles.cardContainer} style={{ maxWidth: "440px" }}>
            <div className={styles.cardHeader}>
              <h2>Create Your Account</h2>
              <p>Join us to explore premium wellness & products</p>
              <div className={styles.quote}>
                "Your wellness journey begins with a single conscious step."
              </div>
            </div>

            <div className={styles.rowGrid}>
              <div>
                <label htmlFor="signup_first_name">First Name</label>
                <input
                  type="text"
                  id="signup_first_name"
                  name="firstName"
                  placeholder="John"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div>
                <label htmlFor="signup_last_name">Last Name</label>
                <input
                  type="text"
                  id="signup_last_name"
                  name="lastName"
                  placeholder="Doe"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div>
              <label htmlFor="signup_email">Email Address</label>
              <input
                type="email"
                id="signup_email"
                name="email"
                placeholder="john.doe@example.com"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div>
              <label htmlFor="signup_phone">Phone Number</label>
              <input
                type="tel"
                id="signup_phone"
                name="phone"
                placeholder="10-digit mobile number"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>

            <div className={styles.rowGrid}>
              <div>
                <label htmlFor="signup_password">Password</label>
                <input
                  type="password"
                  id="signup_password"
                  name="password"
                  placeholder="At least 6 chars"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
              </div>
              <div>
                <label htmlFor="signup_confirm_password">Confirm Password</label>
                <input
                  type="password"
                  id="signup_confirm_password"
                  name="confirmPassword"
                  placeholder="Re-enter password"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            {passwordError && <div className={styles.errorBanner}>{passwordError}</div>}

            <div>
              <button type="submit">
                Create Account <LoginIcon />
              </button>
            </div>

            <div className={styles.linkBox}>
              <p>
                Already have an account? <Link to={"/login"}>Sign In</Link>
              </p>
            </div>
          </div>
        </Form>
      )}
      {flash && (
        <FlashMessage
          message={flash.message}
          type={flash.type}
          mode={flash.mode}
          onClose={hideMessage}
        />
      )}
    </Page>
  )
}

export default SignUp
